import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

//BOOTSTRAP
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

Vue.use(BootstrapVue)
Vue.use(IconsPlugin)

//V-MASK
import VueMask from 'v-mask'
Vue.use(VueMask);

// import VueYoutube from 'vue-youtube'
// Vue.use(VueYoutube)
import vueVimeoPlayer from 'vue-vimeo-player'

Vue.use(vueVimeoPlayer)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
